<template>
  <page-template type="rightpanel">
    <template v-slot:toolbar>
      <tool-bar type="back-arrow" title="Nouvelle loterie" linkback="/gestion-points/loterie"></tool-bar>
    </template>
    <template v-slot:central-panel-content>
      <div class="padding-x">
        <div>
          <v-form class="form-new-element">
            <v-container>
              <div>
                <v-select v-model="lottery.category" :items="lotteryCategory" item-text="name" item-value="_id" label="Type de loterie" outlined></v-select>
                <v-text-field v-model="lottery.title" label="Titre de la loterie" outlined></v-text-field>
                <v-text-field v-model="lottery.description" label="Descriptif de la loterie" outlined></v-text-field>
                <v-select v-model="lottery.recipients" :items="recipients" item-text="name" item-value="_id" label="Choisir les destinataires" multiple chips deletable-chips outlined></v-select>
                <v-row class="d-flex fill-height no-gutters justify-space-between">
                  <v-col class="d-flex flex-column col-5">
                    <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field :value="displayDate" persistent-hint label="Date de la loterie" append-icon="mdi-calendar-month-outline" readonly outlined v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker :value="inputDate" @change="saveDate($event)" no-title scrollable>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col class="d-flex flex-column col-5">
                    <v-select v-model="lottery.duration" :items="lotteryDuration" item-text="duration" item-value="_id" label="Durée de la loterie" outlined></v-select>
                  </v-col>
                </v-row>
                <v-row class="d-flex fill-height no-gutters justify-space-between">
                  <v-col class="d-flex flex-column col-5">
                    <div class="d-flex">
                      <h3 class="">Les mises</h3>
                      <v-icon>mdi-information</v-icon>
                    </div>
                    <div d-flex>
                      <p>Mise 1</p>
                      <v-text-field v-model="lottery.amount" outlined></v-text-field>
                    </div>
                    <v-btn class="mt-4 mx-4">Ajouter une mise</v-btn>
                  </v-col>
                  <v-col class="d-flex flex-column col-5">
                    <div class="d-flex">
                      <h3 class="">Les paris</h3>
                      <v-icon>mdi-information</v-icon>
                    </div>
                    <div d-flex>
                      <p>Mise 1</p>
                      <v-select v-model="lottery.duration" :items="lotteryDuration" item-text="duration" item-value="_id" outlined></v-select>
                    </div>
                    <v-btn class="mt-4 mx-4">Ajouter un pari</v-btn>
                  </v-col>
                </v-row>
              </div>
              <div class="d-flex justify-center">
                <v-btn @click="save(false)" class="mt-4 mx-4 primary-button outlined">Enregistrer</v-btn>
                <v-btn @click="save(true)" class="mt-4 mx-4 primary-button">Publier</v-btn>
              </div>
            </v-container>
          </v-form>
        </div>
      </div>
    </template>
    <template v-slot:right-panel-content>
      <guide-creation
        title="Aide à la création de la loterie"
        text="Le titre doit être court. Soyez précis sur le descriptif. Les points maximum...."
      ></guide-creation>
    </template>
  </page-template>
</template>

<script>
  import pageTemplate from '@/templates/PageTemplate.vue'
  import toolBar from '@/components/ToolBar.vue'
  import guideCreation from '@/components/GuideCreation.vue'
  import axios from 'axios'
  import { apiURL } from '@/../config'
  export default {
    name: 'GestionPointsLoterieNew',
    components: { pageTemplate, toolBar, guideCreation },
      data: () => {
        return {
            lotteryCategory: [],
            recipients: [],
            lotteryDuration: [],
            lottery: {
                category: '',
                title: '',
                description: '',
                recipients: [],
                updateAt: new Date(),
                duration: '',
                amount: 0,
                activated: false
            },
            menu: false
        }
    },
    computed: {
        displayDate () {
            return this.formatDate(this.lottery.updateAt)
        },
        inputDate () {
            const d = new Date(this.lottery.updateAt)
            return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`
        }
    },
    async created () {
        try {
            // LOTTERY CATEGORIES
            const lotteryCategoriesRes = await axios.get(`${apiURL}/lottery/categories`)
            this.lotteryCategory = lotteryCategoriesRes.data.model
            // DURATIONS
            const durationsRes = await axios.get(`${apiURL}/lottery/durations`)
            this.lotteryDuration = durationsRes.data.model
            // RECIPIENTS
            const RecipientsRes = await axios.get(`${apiURL}/data/apartments`)
            this.recipients = RecipientsRes.data.model
        } catch (e) {
            alert('Une erreur est survenue, veuillez réessayer.')
            console.log(e)
        }
    },
    methods: {
        // FORMAT DATE
        formatDate (date) {
            if (!date) return null
            const d = new Date(date)
            const year = d.getFullYear()
            const month = d.getMonth()
            const day = d.getDate()
            return `${day < 10 ? 0 : ''}${day}/${month + 1 < 10 ? 0 : ''}${month + 1}/${year}`
        },
        // DRAFT OR PUBLISH NEW LOTTERY
        async save (isDraft) {
            this.$store.dispatch('loading')
            try {
                this.lottery.activated = isDraft
                await axios.post(`${apiURL}/lottery/new`, this.lottery)
                this.$router.push('/gestion-points/loterie')
            } catch (e) {
                alert('Une erreur est survenue, veuillez réessayer.')
                console.log(e)
            } finally {
                this.$store.dispatch('stop_loading')
            }
        },
        saveDate (date) {
            this.$refs.menu.save()
            const myDate = date.split('-')
            const newDate = new Date(myDate[0], myDate[1] - 1, myDate[2])
            this.lottery.updateAt = newDate.getTime()
        }
    }
  }
</script>